<!-- <ideal-vertical-logo></ideal-vertical-logo> -->
<ideal-vertical-logo color="tertiary"></ideal-vertical-logo>
